import React, { useEffect, useState, useMemo, useRef } from "react"
import { useReactToPrint } from "react-to-print"
import QRCode from "qrcode.react"

import PropTypes from "prop-types"
import { Link, useNavigate } from "react-router-dom"
import classnames from "classnames"
import "../../assets/style/style.css"
import DeleteModal from "components/Common/DeleteModal"

import {
  Card,
  CardBody,
  CardTitle,
  InputGroup,
  Button,
  Col,
  Container,
  UncontrolledTooltip,
  Badge,
  Row,
  Spinner,
  Label,
  Table,
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup,
  Input,
  Nav,
  NavItem,
  NavLink,
  ModalFooter,
  TabContent,
  TabPane,
} from "reactstrap"

import { Type, Coin } from "../EcsUsers/userstabledata"

import TableContainer from "../../components/Common/TableContainer"

// import img2 from "../../assets/images/no-time-off.59f54e64.svg"

//Date Picker
import "react-datepicker/dist/react-datepicker.css"
import "assets/scss/datatables.scss"

// import { cryptoOrderData } from "../../../common/data";

//Import Breadcrumb

import toastr from "toastr"
import "toastr/build/toastr.min.css"
import axios from "axios"
import profile from "assets/images/ecs234.jpg"
import { use } from "i18next"
import Select from "react-select"
import apiURl from "url"
import excelIcon from "../../../src/assets/images/excel.svg"
import LeadsDownload from "components/Common/Excel"
import PdfLeadsDownload from "components/Common/Pdf"
function formatAmountCurrency(amount, currency) {
  return amount.toLocaleString("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
  })
}

const TodayCourierDetail = props => {
  //meta title
  document.title = "All Courier"
  const navigate = useNavigate()

  const role = localStorage.getItem("role")
  const user_id = localStorage.getItem("login_user_id")
  const assigned_users =
    JSON.parse(localStorage.getItem("assigned_users")) || []

  const printRef = useRef()
  const [todayDate, setTodayDate] = useState(
    new Date().toISOString().split("T")[0]
  )

  //Table Data
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(false)
  ////Document Charges Amount
  const [DocumentChargesAmount, setDocumentChargesAmount] = useState([])
  const [UnpaidDocumentChargesAmount, setUnpaidDocumentChargesAmount] =
    useState([])
  //Print Data

  const [DocumentMode, setDocumentMode] = useState(false)
  const [editID, setEditID] = useState(null)
  const [print, setPrint] = useState(false)
  const [printClicked, setPrintClicked] = useState(false) // Flag to track print button click
  const [cvimode, setCvimode] = useState(false)
  const [trackID, setTrackID] = useState("")
  const [TotalRevenue, setTotalRevenue] = useState([])
  const [UnpaidAmount, setUnpaidAmount] = useState([])
  const [Ffdata, setFfdata] = useState([])
  const [fdata, setFdata] = useState({
    s_name: "",
    s_phone: "",
    s_address: "",

    r_name: "",
    r_phone: "",
    r_address: "",

    staus: "",

    b_date: "",

    service_name: "",
    employee_name: "",
    employee_id: "",

    ecs_track_id: "",

    ser_charges: "",
    Dser_caharges: "",

    content_name: "",
    parcel_price: "",
    parcel_weight: "",
    parcel_cvi_status: "",
    no_of_products: "",

    from_loca: "",
    rec_loca: "",

    no_of_doc: "",
    office_del: "",
    city_del: "",
    docs_cvi_status: "",
    docs_detail: "",
    docs_cvi_amount: "",
    rider_charges: "0",
    doc_sub_service: "",

    dep_charges_type: null,
    dep_charges_amount: null,

    pay_method: "",
    noOfWorkingDays:""
  })
  const [DepChargesData, setDepChargesData] = useState([])

  //Fetch Print Data
  const ParceldataforPrint = async id => {
    try {
      const URL = `${apiURl}/fetchParcelDetailsByID`
      const response = await axios.post(URL, { id })
      if (response.data.status === "success") {
        const parcelDetailsByID = response.data.parcelDetailsByID
        setDepChargesData(parcelDetailsByID[0].dep_charges_data)
        if (parcelDetailsByID.length > 0) {
          setFdata(prevData => ({
            ...prevData,
            s_name: parcelDetailsByID[0].sender_full_name || "",
            s_phone: parcelDetailsByID[0].sender_phone || "",
            s_address: parcelDetailsByID[0].sender_address || "",

            r_name: parcelDetailsByID[0].receiver_full_name || "",
            r_phone: parcelDetailsByID[0].receiver_phone || "",
            r_address: parcelDetailsByID[0].receiver_address || "",

            staus: parcelDetailsByID[0].status_ || "",

            b_date: parcelDetailsByID[0].created_date || "",

            service_name: parcelDetailsByID[0].service_name || "",
            employee_name: parcelDetailsByID[0].employee_name || "",
            employee_id: parcelDetailsByID[0].employee_id || "",

            ecs_track_id: parcelDetailsByID[0].track_id || "",

            ser_charges: parcelDetailsByID[0].total_price || "",
            Dser_caharges: parcelDetailsByID[0].docs_total_price || "",

            from_loca: parcelDetailsByID[0].send_location || "",
            rec_loca: parcelDetailsByID[0].receive_location || "",

            content_name: parcelDetailsByID[0].parcel_info || "",
            parcel_price: parcelDetailsByID[0].parcel_price || "",
            parcel_weight: parcelDetailsByID[0].parcel_weight || "",
            parcel_cvi_status: parcelDetailsByID[0].parcel_cvi_value || "",
            no_of_products: parcelDetailsByID[0].no_of_products || "",
            rider_charges: parcelDetailsByID[0].rider_charges || "",
            no_of_doc: parcelDetailsByID[0].no_of_docs || "",
            office_del: parcelDetailsByID[0].docs_office_type || "",
            city_del: parcelDetailsByID[0].docs_city_type || "",
            docs_cvi_status: parcelDetailsByID[0].docs_cvi_value || "",
            docs_cvi_amount: parcelDetailsByID[0].doc_cvi_amount || "",
            docs_detail: parcelDetailsByID[0].docs_detail || "",
            doc_sub_service: parcelDetailsByID[0].doc_sub_service || "",

            dep_charges_type: parcelDetailsByID[0].dep_charges_type || "",
            dep_charges_amount: parcelDetailsByID[0].dep_charges_amount || "",

            pay_method: parcelDetailsByID[0].payment_method || "",
            noOfWorkingDays: parcelDetailsByID[0]?.noOfWorkingDays || "",
          }))
          setCvimode(parcelDetailsByID[0].docs_cvi_value === "1")
          setPrint(true)
          setEditID(id)
          setTrackID(parcelDetailsByID[0].track_id || "")
          setPrintClicked(true)
          if (parcelDetailsByID[0].service_name === "Docs. Attestation") {
            setDocumentMode(true)
          } else {
            setDocumentMode(false)
          }
        } else {
          console.error("No data found")
        }
      } else {
        console.error("Failed to fetch data:", response.data.message)
      }
    } catch (error) {
      console.error("Error fetching data:", error)
    }
  }

  const fetchTodayParcelinfo = (Role, User_id) => {
    setOrders([])
    setFfdata([])
    setLoading(true)
    const data = {
      role: Role,
      user_id: User_id,
      assigned_users: assigned_users,
    }
    const URL = `${apiURl}/fetchTodayParcelDetails`
    axios
      .post(URL, data)
      .then(response => {
        if (response.data.status === "success") {
          const Data = response.data.parcelDetails
          setOrders(Data)
          setFfdata(Data)
          setLoading(false)

          let TotalParcelAmount = 0
          let TotalDocAmount = 0
          let ParcelCviAmount = 0
          let DocCviAmount = 0
          let DocumnetChargesAmount = 0
          let riderCharges = 0

          let UnpaidParcelAmount = 0
          let UnpaidDocAmount = 0
          let UnpaidParcelCvi = 0
          let UnpaidDocCvi = 0
          let UnpaidDocumnetChargesAmount = 0
          let UnpaidRiderCharges = 0

          Data.forEach(item => {
            const totalPrice = parseFloat(item.total_price) || 0
            const docsPrice = parseFloat(item.docs_total_price) || 0
            const parcelPrice = parseFloat(item.parcel_price) || 0
            const docCvi = parseFloat(item.doc_cvi_amount) || 0
            const depCharges = parseFloat(item.dep_charges_amount) || 0
            const riderCharge =
              item.rider_charges && parseFloat(item.rider_charges) > 0
                ? parseFloat(item.rider_charges)
                : 0

            // Totals for all
            TotalParcelAmount += totalPrice
            TotalDocAmount += docsPrice
            ParcelCviAmount += parcelPrice
            DocCviAmount += docCvi
            DocumnetChargesAmount += depCharges
            riderCharges += riderCharge

            if (item.payment_status === "not-paid") {
              UnpaidParcelAmount += totalPrice
              UnpaidDocAmount += docsPrice
              UnpaidParcelCvi += parcelPrice
              UnpaidDocCvi += docCvi
              UnpaidDocumnetChargesAmount += depCharges
              UnpaidRiderCharges += riderCharge
            }
          })

          // ---- Total Calculation for All Rows ----
          const TotalAmount = TotalParcelAmount + TotalDocAmount
          const TotalCviAmount = ParcelCviAmount + DocCviAmount
          const CviPercent = TotalCviAmount * 0.025
          const ForGST = TotalAmount - CviPercent - riderCharges
          const GSTAmount = ForGST * 0.15
          const TotalAmountWithGST = TotalAmount + GSTAmount
          setTotalRevenue(TotalAmountWithGST)

          // ---- Unpaid Amount with Same Logic ----
          const UnpaidTotalAmount = UnpaidParcelAmount + UnpaidDocAmount
          const UnpaidCviAmount = UnpaidParcelCvi + UnpaidDocCvi
          const UnpaidCviPercent = UnpaidCviAmount * 0.025
          const UnpaidForGST =
            UnpaidTotalAmount - UnpaidCviPercent - UnpaidRiderCharges
          const UnpaidGST = UnpaidForGST * 0.15
          const UnpaidTotalWithGST = UnpaidTotalAmount + UnpaidGST
          setUnpaidAmount(UnpaidTotalWithGST)

          setDocumentChargesAmount(DocumnetChargesAmount)
          setUnpaidDocumentChargesAmount(UnpaidDocumnetChargesAmount)
        } else {
          console.error("Failed to fetch users:", response.data.message)
          setLoading(true)
        }
      })
      .catch(error => {
        console.error("Error fetching users:", error)
        setLoading(true)
      })
  }

  useEffect(() => {
    fetchTodayParcelinfo(role, user_id)
  }, [role, user_id])

  //Modals
  const [modalType, setModalType] = useState(null) // "status" | "assign" | "amount"
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)
  const [paymentStatus, setPaymentStatus] = useState(null)

  const handleUpdatePaidStatus = async () => {
    try {
      const payload = {
        id: selectedRow?.req_id, // Make sure you use selectedRow
        payment_status: paymentStatus,
      }

      await axios.post(`${apiURl}/updatePaidStatus`, payload)
      setIsModalOpen(false)
      toastr.success("Status updated successfully")
      fetchTodayParcelinfo(role, user_id)
    } catch (error) {
      toastr.error("Error updating status")
    }
  }

  // Table Data
  const columns = useMemo(
    () => [
      {
        Header: "No.",
        accessor: "courier_id",
        disableFilters: true,

        Cell: cellProps => {
          return <>{cellProps.row.index + 1}</>
        },
      },
      {
        Header: "ECS Track ID",
        accessor: "track_id",
        disableFilters: true,
        Cell: cellProps => {
          return <Type {...cellProps} />
        },
      },
      {
        Header: "Book City",
        accessor: "book_city",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <>
              {cellProps.value
                ? cellProps.value.charAt(0).toUpperCase() +
                  cellProps.value.slice(1)
                : ""}
            </>
          )
        },
      },
      {
        Header: "Service",
        accessor: "service_name",
        disableFilters: true,
        Cell: cellProps => {
          return <Coin {...cellProps} />
        },
      },
      {
        Header: "Status",
        accessor: "status_",
        disableFilters: true,
        Cell: cellProps => {
          const statusMap = {
            new: { label: "New", className: "bg-info" },
            cancel: { label: "Cancelled", className: "bg-danger" },
            "in-progress": { label: "In Progress", className: "bg-warning" },
            dispatch: { label: "Dispatched", className: "bg-warning" },
            "foreign-office-submit": {
              label: "Submitted to Foreign Office",
              className: "bg-warning",
            },
            collect: { label: "Ready to Collect", className: "bg-success" },
            delivered: { label: "Delivered", className: "bg-success" },
            resubmit: { label: "Resubmit", className: "bg-secondary" },
          }

          const status = statusMap[cellProps.value] || {
            label: cellProps.value,
            className: "bg-secondary",
          }

          return (
            <Badge pill className={`${status.className} font-size-12`}>
              {status.label}
            </Badge>
          )
        },
      },

      {
        Header: "Assign Status",
        accessor: "assign_status",
        disableFilters: true,
        Cell: cellProps => {
          const statusMap = {
            NotAssign: "bg-danger",
            assigned: "bg-success",
          }
          return (
            <Badge
              pill
              className={`${
                statusMap[cellProps.value]
              } font-size-10 text-uppercase`}
            >
              {cellProps.value.replace(/NotAssign/g, "Not Assigned")}
            </Badge>
          )
        },
      },
      {
        Header: "Total Amount",
        accessor: "amount",
        disableFilters: true,
        Cell: cellProps => {
          const pStatus = cellProps.row.original.payment_status || null
          // Determine badge text
          const isPaid = !pStatus || pStatus === "paid" // true if null or "paid"
          const PStatusView = isPaid ? "P" : "NP"

          // Determine badge color
          const badgeClass =
            pStatus === "paid" || !pStatus ? "bg-success" : "bg-danger"

          const parcelAmount =
            parseFloat(cellProps.row.original.total_price) || 0
          const documentAmount =
            parseFloat(cellProps.row.original.docs_total_price) || 0

          const depChargesAmount = cellProps.row.original.dep_charges_amount
            ? parseFloat(cellProps.row.original.dep_charges_amount)
            : 0

          const parcelCviAmount =
            parseFloat(cellProps.row.original.parcel_price) || 0
          const docCviAmount =
            parseFloat(cellProps.row.original.doc_cvi_amount) || 0

          const riderCharges =
            cellProps.row.original.rider_charges &&
            parseFloat(cellProps.row.original.rider_charges) > 0
              ? parseFloat(cellProps.row.original.rider_charges)
              : 0

          const parcelCviPercent = parcelCviAmount * 0.025
          const docCviPercent = docCviAmount * 0.025

          let PA_FOR_GST =
            (parcelAmount - parcelCviPercent - riderCharges) * 0.15 +
            parcelAmount
          let DA_FOR_GST =
            (documentAmount - docCviPercent - riderCharges) * 0.15 +
            documentAmount

          DA_FOR_GST += depChargesAmount

          const service = cellProps.row.original.service_name
          const totalAmount =
            service === "Docs. Attestation" ? DA_FOR_GST : PA_FOR_GST

          return (
            <span>
              {formatAmountCurrency(totalAmount, "PKR")}
              <Badge pill className={`mx-2 ${badgeClass}`}>
                {PStatusView}
              </Badge>
              {!pStatus || pStatus === "paid" ? (
                <></>
              ) : (
                <i
                  className="bx bx-edit"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setModalType("PaidStatus")
                    setPaymentStatus(
                      cellProps.row.original.payment_status || "not-paid"
                    )
                    setSelectedRow(cellProps.row.original)
                    setIsModalOpen(true)
                  }}
                ></i>
              )}
            </span>
          )
        },
      },

      {
        Header: "Booking Date",
        accessor: "created_date",
        disableFilters: true,
        Cell: cellProps => {
          return <Coin {...cellProps} />
        },
      },
      {
        Header: "Action",
        accessor: "id2",
        disableFilters: true,
        Cell: cellProps => {
          const id = cellProps.row.original.courier_id
          return (
            <>
              <div className="d-flex gap-2">
                <Link
                  onClick={() => {
                    ParceldataforPrint(id)
                  }}
                  className="text-primary"
                >
                  <i className="mdi mdi-printer font-size-18" id="print" />
                  <UncontrolledTooltip placement="top" target="print">
                    print
                  </UncontrolledTooltip>
                </Link>
                <Link
                  to={`/view/courier_detail/${id}`}
                  className="text-primary"
                >
                  <i className="mdi mdi-eye font-size-18" id="viewtooltip" />
                  <UncontrolledTooltip placement="top" target="viewtooltip">
                    view
                  </UncontrolledTooltip>
                </Link>
                <Link
                  onClick={() => {
                    deleteParcel(id)
                  }}
                  className="text-danger"
                >
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                  />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Delete
                  </UncontrolledTooltip>
                </Link>
              </div>
            </>
          )
        },
      },
    ],
    []
  )

  //handle Print
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  })

  useEffect(() => {
    if (print && printClicked) {
      handlePrint()
      setPrintClicked(false)
    }
  }, [print, printClicked, handlePrint])

  //Location
  const SEND = fdata.from_loca.substr(0, 3).toUpperCase()
  const REC = fdata.rec_loca.substr(0, 3).toUpperCase()

  //Calculation
  const Pcharges = parseFloat(fdata.ser_charges)
  const Dcharges = parseFloat(fdata.Dser_caharges)
  const riderCharges =
    fdata.rider_charges && parseFloat(fdata.rider_charges) > 0
      ? parseFloat(fdata.rider_charges)
      : 0
  let ParcelChargesWithoutCVi = 0
  let ParcelCviAmount = 0
  let ParcelGSTAmount = 0
  let TotalParCharges = 0

  let DocAmountWithountcvi
  let DocCviAmount = 0
  let DocgstAmount = 0
  let TotalDocCharges = 0

  let depChargesAmount = fdata.dep_charges_amount
    ? parseFloat(fdata.dep_charges_amount)
    : 0

  // Parcel Logic
  if (fdata.parcel_cvi_status === "1") {
    ParcelCviAmount = parseFloat(fdata.parcel_price) * 0.025
    ParcelChargesWithoutCVi = Pcharges - ParcelCviAmount - riderCharges
    ParcelGSTAmount = ParcelChargesWithoutCVi * 0.15
    TotalParCharges =
      ParcelChargesWithoutCVi + ParcelCviAmount + ParcelGSTAmount + riderCharges
  } else {
    ParcelChargesWithoutCVi = Pcharges - riderCharges
    ParcelGSTAmount = ParcelChargesWithoutCVi * 0.15
    TotalParCharges = ParcelChargesWithoutCVi + ParcelGSTAmount + riderCharges
  }

  // Document Logic
  if (fdata.docs_cvi_status === "1") {
    DocCviAmount = parseFloat(fdata.docs_cvi_amount) * 0.025
    DocAmountWithountcvi = Dcharges - DocCviAmount - riderCharges
    DocgstAmount = DocAmountWithountcvi * 0.15
    TotalDocCharges =
      DocAmountWithountcvi +
      DocCviAmount +
      DocgstAmount +
      depChargesAmount +
      riderCharges
  } else {
    DocAmountWithountcvi = Dcharges - riderCharges
    DocgstAmount = DocAmountWithountcvi * 0.15
    TotalDocCharges =
      DocAmountWithountcvi + DocgstAmount + depChargesAmount + riderCharges
  }

  useEffect(() => {
    if (fdata.docs_cvi_status === "1" || fdata.parcel_cvi_status === "1") {
      setCvimode(true)
    } else {
      setCvimode(false)
    }
  }, [fdata.docs_cvi_status, fdata.parcel_cvi_status])

  //////////////////////////////////////////////////////////////////////////

  //Delete Modal
  const [deleteModal, setDeleteModal] = useState(false)
  const [del_id, setDel_id] = useState([])
  const deleteParcel = id => {
    setDel_id(id)
    setDeleteModal(true)
  }

  //Delete Parcel
  const handleDeleteCourier = () => {
    const data = {
      del_id: del_id,
      role: role,
    }
    const URL = `${apiURl}/deleteParcel`
    axios
      .post(URL, data)
      .then(response => {
        if (response.status === 200) {
          fetchTodayParcelinfo(role, user_id)
          setDeleteModal(false)
          toastr.success("Parcel Delete Successfully")
        } else {
          setDeleteModal(false)
          toastr.error("Failed to Delete:", response.data.message)
        }
      })
      .catch(error => {
        toastr.error("Failed to Delete", error)
      })
  }

  //
  const [status, setStatus] = useState(null)
  const [selectedUser, setSelectedUser] = useState(null)
  const [selectedUserCity, setSelectedUserCity] = useState(null)

  //Handle User
  const handleUser = selectedOption => {
    setSelectedUser(selectedOption ? selectedOption.value : null)
  }
  //Handle City
  const handleCity = selectedOption => {
    setSelectedUserCity(selectedOption ? selectedOption.value : null)
  }

  //All User
  const [fetchUsers2, setFetchUsers2] = useState([])
  const [usersCity, setUsersCity] = useState([])
  const [showRequestedOnly, setShowRequestedOnly] = useState(false)
  const [showPaidLeads, setShowPaidLeads] = useState(false)

  const fetchUsers = () => {
    setUsersCity([])
    const URL = `${apiURl}/fetchUsers`
    axios
      .get(URL)
      .then(response => {
        if (response.data.status === "success") {
          const Data = response.data.users
          const uniqueCities = new Set(
            Data.map(user => user.city_.trim().toUpperCase())
          )
          setFetchUsers2(Data)
          setUsersCity(Array.from(uniqueCities))
        } else {
          console.error("Failed to fetch users:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching users:", error)
      })
  }
  useEffect(() => {
    fetchUsers()
  }, [])

  //Filter
  const handleFilter = () => {
    let filter = Ffdata
    if (
      selectedUserCity !== null &&
      selectedUser !== null &&
      status !== null &&
      todayDate !== null
    ) {
      // Filter by selectedUserCity, selectedUser, status, and today's date
      filter = Ffdata.filter(
        item =>
          item.book_city.trim().toUpperCase() === selectedUserCity &&
          item.employee_id === selectedUser &&
          item.status_ === status &&
          item.created_date === todayDate
      )
    } else if (
      selectedUserCity !== null &&
      selectedUser !== null &&
      status !== null &&
      todayDate === null
    ) {
      // Filter by selectedUserCity, selectedUser, and status
      filter = Ffdata.filter(
        item =>
          item.book_city.trim().toUpperCase() === selectedUserCity &&
          item.employee_id === selectedUser &&
          item.status_ === status
      )
    } else if (
      selectedUserCity !== null &&
      selectedUser !== null &&
      status === null &&
      todayDate !== null
    ) {
      // Filter by selectedUserCity, selectedUser, and today's date
      filter = Ffdata.filter(
        item =>
          item.book_city.trim().toUpperCase() === selectedUserCity &&
          item.employee_id === selectedUser &&
          item.created_date === todayDate
      )
    } else if (
      selectedUserCity !== null &&
      selectedUser !== null &&
      status === null &&
      todayDate === null
    ) {
      // Filter by selectedUserCity and selectedUser
      filter = Ffdata.filter(
        item =>
          item.book_city.trim().toUpperCase() === selectedUserCity &&
          item.employee_id === selectedUser
      )
    } else if (
      selectedUserCity !== null &&
      selectedUser === null &&
      status !== null &&
      todayDate !== null
    ) {
      // Filter by selectedUserCity, status, and today's date
      filter = Ffdata.filter(
        item =>
          item.book_city.trim().toUpperCase() === selectedUserCity &&
          item.status_ === status &&
          item.created_date === todayDate
      )
    } else if (
      selectedUserCity !== null &&
      selectedUser === null &&
      status !== null &&
      todayDate === null
    ) {
      // Filter by selectedUserCity and status
      filter = Ffdata.filter(
        item =>
          item.book_city.trim().toUpperCase() === selectedUserCity &&
          item.status_ === status
      )
    } else if (
      selectedUserCity !== null &&
      selectedUser === null &&
      status === null &&
      todayDate !== null
    ) {
      // Filter by selectedUserCity and today's date
      filter = Ffdata.filter(
        item =>
          item.book_city.trim().toUpperCase() === selectedUserCity &&
          item.created_date === todayDate
      )
    } else if (
      selectedUserCity !== null &&
      selectedUser === null &&
      status === null &&
      todayDate === null
    ) {
      // Filter by selectedUserCity only
      filter = Ffdata.filter(
        item => item.book_city.trim().toUpperCase() === selectedUserCity
      )
    } else if (
      selectedUserCity === null &&
      selectedUser !== null &&
      status !== null &&
      todayDate !== null
    ) {
      // Filter by selectedUser, status, and today's date
      filter = Ffdata.filter(
        item =>
          item.employee_id === selectedUser &&
          item.status_ === status &&
          item.created_date === todayDate
      )
    } else if (
      selectedUserCity === null &&
      selectedUser !== null &&
      status !== null &&
      todayDate === null
    ) {
      // Filter by selectedUser and status
      filter = Ffdata.filter(
        item => item.employee_id === selectedUser && item.status_ === status
      )
    } else if (
      selectedUserCity === null &&
      selectedUser !== null &&
      status === null &&
      todayDate !== null
    ) {
      // Filter by selectedUser and today's date
      filter = Ffdata.filter(
        item =>
          item.employee_id === selectedUser && item.created_date === todayDate
      )
    } else if (
      selectedUserCity === null &&
      selectedUser !== null &&
      status === null &&
      todayDate === null
    ) {
      // Filter by selectedUser only
      filter = Ffdata.filter(item => item.employee_id === selectedUser)
    } else if (
      selectedUserCity === null &&
      selectedUser === null &&
      status !== null &&
      todayDate !== null
    ) {
      // Filter by status and today's date
      filter = Ffdata.filter(
        item => item.status_ === status && item.created_date === todayDate
      )
    } else if (
      selectedUserCity === null &&
      selectedUser === null &&
      status !== null &&
      todayDate === null
    ) {
      // Filter by status only
      filter = Ffdata.filter(item => item.status_ === status)
    } else if (
      selectedUserCity === null &&
      selectedUser === null &&
      status === null &&
      todayDate !== null
    ) {
      // Filter by today's date only
      filter = Ffdata.filter(item => item.created_date === todayDate)
    } else {
      // No filter applied
      filter = Ffdata
    }
    let TotalParcelAmount = 0
    let TotalDocAmount = 0
    let ParcelCviAmount = 0
    let DocCviAmount = 0
    let DocumnetChargesAmount = 0
    let riderCharges = 0

    let UnpaidParcelAmount = 0
    let UnpaidDocAmount = 0
    let UnpaidParcelCvi = 0
    let UnpaidDocCvi = 0
    let UnpaidDocumnetChargesAmount = 0
    let UnpaidRiderCharges = 0

    filter.forEach(item => {
      const totalPrice = parseFloat(item.total_price) || 0
      const docsPrice = parseFloat(item.docs_total_price) || 0
      const parcelPrice = parseFloat(item.parcel_price) || 0
      const docCvi = parseFloat(item.doc_cvi_amount) || 0
      const depCharges = parseFloat(item.dep_charges_amount) || 0
      const riderCharge =
        item.rider_charges && parseFloat(item.rider_charges) > 0
          ? parseFloat(item.rider_charges)
          : 0

      // Totals for all
      TotalParcelAmount += totalPrice
      TotalDocAmount += docsPrice
      ParcelCviAmount += parcelPrice
      DocCviAmount += docCvi
      DocumnetChargesAmount += depCharges
      riderCharges += riderCharge

      if (item.payment_status === "not-paid") {
        UnpaidParcelAmount += totalPrice
        UnpaidDocAmount += docsPrice
        UnpaidParcelCvi += parcelPrice
        UnpaidDocCvi += docCvi
        UnpaidDocumnetChargesAmount += depCharges
        UnpaidRiderCharges += riderCharge
      }
    })

    // ---- Total Calculation for All Rows ----
    const TotalAmount = TotalParcelAmount + TotalDocAmount
    const TotalCviAmount = ParcelCviAmount + DocCviAmount
    const CviPercent = TotalCviAmount * 0.025
    const ForGST = TotalAmount - CviPercent - riderCharges
    const GSTAmount = ForGST * 0.15
    const TotalAmountWithGST = TotalAmount + GSTAmount
    setTotalRevenue(TotalAmountWithGST)

    // ---- Unpaid Amount with Same Logic ----
    const UnpaidTotalAmount = UnpaidParcelAmount + UnpaidDocAmount
    const UnpaidCviAmount = UnpaidParcelCvi + UnpaidDocCvi
    const UnpaidCviPercent = UnpaidCviAmount * 0.025
    const UnpaidForGST =
      UnpaidTotalAmount - UnpaidCviPercent - UnpaidRiderCharges
    const UnpaidGST = UnpaidForGST * 0.15
    const UnpaidTotalWithGST = UnpaidTotalAmount + UnpaidGST
    setUnpaidAmount(UnpaidTotalWithGST)

    setDocumentChargesAmount(DocumnetChargesAmount)
    setUnpaidDocumentChargesAmount(UnpaidDocumnetChargesAmount)
    setOrders(filter)
  }

  //Clear Filtre
  const handleClearFilter = () => {
    setOrders(Ffdata)
    setSelectedUser(null)
    setShowRequestedOnly(false)
    setShowPaidLeads(false)
    setSelectedUserCity(null)
    fetchTodayParcelinfo(role, user_id)
    setStatus(null)
  }
  //Lead From Request
  const leadsFromRequest = () => {
    if (showRequestedOnly) {
      setOrders(Ffdata)
    } else {
      // Filter to show only those with req_id !== null
      const filtered = Ffdata.filter(
        item => item.req_id !== null && item.req_id !== ""
      )
      setOrders(filtered)
    }
    setShowRequestedOnly(prev => !prev)
  }

  //Unpaid Leads
  const UnpaidLeads = () => {
    if (showPaidLeads) {
      setOrders(Ffdata)
      toastr.success("All Leads Are Shown")
    } else {
      const filtered = Ffdata.filter(item => item.payment_status === "not-paid")
      setOrders(filtered)
      toastr.success("Only Not Paid Leads Are filterd")
    }
    setShowPaidLeads(prev => !prev)
  }

  //Tabs
  const [activeTab, setActiveTab] = useState("inhouse")

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  const inhouseColumns = useMemo(() => {
    return columns.filter(col => col.Header !== "Assign Status")
  }, [columns])

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteCourier}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          {/* <Breadcrumbs title="Crypto" breadcrumbItem="Orders" /> */}
          <Row className="mb-3">
            <Col xl="6">
              <div>
                <h5 className="mt-2">Today Book Courier's</h5>
              </div>
            </Col>
          </Row>
          {role === "admin" && (
            <Row>
              <Col md="3">
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">
                          Today Total Revenue
                        </p>
                        <h4 className="mb-0">
                          {loading ? (
                            <Spinner />
                          ) : TotalRevenue ? (
                            formatAmountCurrency(TotalRevenue, "PKR")
                          ) : (
                            "0"
                          )}
                        </h4>
                      </div>
                      <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-primary">
                          <i className={"bx bx-archive-in font-size-24"}></i>
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="3">
                <Card
                  className="mini-stats-wid"
                  style={{
                    backgroundColor: "#DEEAF7",
                    boxShadow:
                      "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.08)",
                  }}
                >
                  <CardBody onClick={UnpaidLeads} style={{ cursor: "pointer" }}>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <small style={{ color: "red" }}>
                          {showPaidLeads
                            ? "Fetch All Leads"
                            : "Filter Non-Paid Leads"}
                        </small>
                        <p className="text-muted fw-medium">
                          Today Unpaid Amount
                        </p>
                        <h4 className="mb-0" style={{ color: "red" }}>
                          {loading ? (
                            <Spinner />
                          ) : UnpaidAmount ? (
                            formatAmountCurrency(UnpaidAmount, "PKR")
                          ) : (
                            "0"
                          )}
                        </h4>
                      </div>
                      <div className="avatar-sm rounded-circle bg-danger align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-danger">
                          <i className={"bx bx-archive-in font-size-24"}></i>
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="3">
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">
                          Today Document Charges
                        </p>
                        <h4 className="mb-0">
                          {loading ? (
                            <Spinner />
                          ) : DocumentChargesAmount ? (
                            formatAmountCurrency(DocumentChargesAmount, "PKR")
                          ) : (
                            "0"
                          )}
                        </h4>
                      </div>
                      <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-primary">
                          <i className={"bx bx-archive-in font-size-24"}></i>
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md="3">
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">
                          Unpaid Document Charges
                        </p>
                        <h4 className="mb-0" style={{ color: "red" }}>
                          {loading ? (
                            <Spinner />
                          ) : UnpaidDocumentChargesAmount ? (
                            formatAmountCurrency(
                              UnpaidDocumentChargesAmount,
                              "PKR"
                            )
                          ) : (
                            "0"
                          )}
                        </h4>
                      </div>
                      <div className="avatar-sm rounded-circle bg-danger align-self-center mini-stat-icon">
                        <span className="avatar-title rounded-circle bg-danger">
                          <i className={"bx bx-archive-in font-size-24"}></i>
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {role === "admin" ? (
            <Card>
              <CardBody>
                <Row className="mb-3">
                  <Col xl={3}>
                    <div className="col-sm-auto">
                      <Label
                        className="control-label"
                        htmlFor="selectedUserCity"
                      >
                        City
                      </Label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={
                          usersCity
                            .map(city => ({ value: city, label: city })) // Map to options
                            .find(
                              option => option.value === selectedUserCity
                            ) || null // Match selected value
                        }
                        placeholder="Select City ..."
                        name="selectedUserCity"
                        onChange={handleCity}
                        options={[
                          ...(usersCity.length > 0
                            ? usersCity.map(city => ({
                                value: city,
                                label: city,
                              }))
                            : [{ value: "", label: "No data Found" }]),
                        ]}
                      />
                    </div>
                  </Col>
                  <Col xl={3}>
                    <div className="col-sm-auto">
                      <Label className="control-label" htmlFor="selectedUser">
                        User
                      </Label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={
                          fetchUsers2
                            .map(e => ({
                              value: e.user_id,
                              label: `${e.role_
                                .substring(0, 2)
                                .toUpperCase()}: ${e.full_name} (${e.city_})`,
                            }))
                            .find(option => option.value === selectedUser) ||
                          null
                        }
                        placeholder="Select User ..."
                        name="selectedUser"
                        onChange={handleUser}
                        options={[
                          ...(fetchUsers2.length > 0
                            ? fetchUsers2.map(e => ({
                                value: e.user_id,
                                label: `${e.role_
                                  .substring(0, 2)
                                  .toUpperCase()}: ${e.full_name} (${e.city_})`,
                              }))
                            : [{ value: "", label: "No data Found" }]),
                        ]}
                      />
                    </div>
                  </Col>
                  <Col xl={2}>
                    <div className="col-sm-auto">
                      <label className="" htmlFor="autoSizingSelect">
                        Status
                      </label>
                      <select
                        className="form-select"
                        name="change_status"
                        value={status || ""}
                        onChange={e =>
                          setStatus(
                            e.target.value == "" ? null : e.target.value
                          )
                        }
                      >
                        <option value="">Select status ...</option>
                        <option value="new">New</option>
                        <option value="in-progress">In Progress</option>
                        <option value="dispatch">Dispatch</option>
                        <option value="foreign-office-submit">
                          Submitted to Foreign office
                        </option>
                        <option value="collect">Ready To Collect</option>
                        <option value="delivered">Delivered</option>
                        <option value="resubmit">Resubmit</option>
                        <option value="cancel">Cancel</option>
                      </select>
                    </div>
                  </Col>
                  <Col xl={2}>
                    <label className="" htmlFor="example-date-input">
                      Date
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control"
                        type="date"
                        id="example-date-input"
                        value={todayDate}
                        onChange={e =>
                          setTodayDate(
                            e.target.value !== "" ? e.target.value : null
                          )
                        }
                        disabled
                      />
                    </div>
                  </Col>
                  <Col xl={2}>
                    <Button
                      className="btn btn-primary mt-4"
                      color="primary"
                      onClick={handleFilter}
                    >
                      Filter Result
                    </Button>
                  </Col>
                  <Col xl={2}>
                    <Button
                      className="btn btn-danger mt-4"
                      color="danger"
                      onClick={handleClearFilter}
                    >
                      Clear Filter
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ) : (
            <Card>
              <CardBody>
                <Row className="mb-3">
                  <Col xl={2}>
                    <div className="col-sm-auto">
                      <label className="" htmlFor="autoSizingSelect">
                        Status
                      </label>
                      <select
                        className="form-select"
                        name="change_status"
                        value={status || ""}
                        onChange={e =>
                          setStatus(
                            e.target.value == "" ? null : e.target.value
                          )
                        }
                      >
                        <option value="">Select status ...</option>
                        <option value="new">New</option>
                        <option value="in-progress">In Progress</option>
                        <option value="dispatch">Dispatch</option>
                        <option value="foreign-office-submit">
                          Submitted to Foreign office
                        </option>
                        <option value="collect">Ready To Collect</option>
                        <option value="delivered">Delivered</option>
                        <option value="cancel">Cancel</option>
                      </select>
                    </div>
                  </Col>
                  <Col xl={2}>
                    <label className="" htmlFor="example-date-input">
                      Date
                    </label>
                    <div className="col-md-10">
                      <input
                        className="form-control"
                        type="date"
                        id="example-date-input"
                        defaultValue={todayDate}
                        onChange={e =>
                          setTodayDate(
                            e.target.value !== "" ? e.target.value : null
                          )
                        }
                        disabled
                      />
                    </div>
                  </Col>
                  <Col xl={2}>
                    <Button
                      className="btn btn-primary mt-4"
                      color="primary"
                      onClick={handleFilter}
                    >
                      Filter
                    </Button>
                  </Col>
                  <Col xl={2}>
                    <Button
                      className="btn btn-danger mt-4"
                      color="danger"
                      onClick={handleClearFilter}
                    >
                      Clear Filter
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          )}

          <Row className="mb-3">
            <Col lg="12">
              {loading ? (
                <Spinner className="ms-2" color="primary" />
              ) : (
                <Card>
                  <CardBody>
                    <div className="float-end mt-3">
                      <LeadsDownload leads={orders} />
                    </div>

                    <Nav tabs className="d-flex gap-2 flex-wrap">
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: activeTab === "inhouse",
                          })}
                          onClick={() => toggleTab("inhouse")}
                          style={{
                            backgroundColor:
                              activeTab === "inhouse" ? "#50A5F1" : "#f8f9fa",
                            color:
                              activeTab === "inhouse" ? "white" : "#6c757d",

                            border: "1px solid #D7DADE",
                            transition: "0.3s",
                          }}
                        >
                          <i
                            className="bx bxs-user-rectangle"
                            style={{ marginRight: "5px" }}
                          ></i>{" "}
                          Walk-in Customers
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: activeTab === "requests",
                          })}
                          onClick={() => toggleTab("requests")}
                          style={{
                            backgroundColor:
                              activeTab === "requests" ? "#F1B44C" : "#f8f9fa",
                            color:
                              activeTab === "requests" ? "white" : "#6c757d",

                            border: "1px solid #D7DADE",
                            transition: "0.3s",
                          }}
                        >
                          <i
                            className="bx bxs-mobile-vibration"
                            style={{ marginRight: "5px" }}
                          ></i>{" "}
                          App Customers{" "}
                        </NavLink>
                      </NavItem>
                    </Nav>

                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="inhouse">
                        <TableContainer
                          columns={inhouseColumns}
                          data={orders.filter(order => !order.req_id)}
                          isGlobalFilter={true}
                          isAddOptions={false}
                          customPageSize={10}
                        />
                      </TabPane>
                      <TabPane tabId="requests">
                        <TableContainer
                          columns={columns}
                          data={orders.filter(order => order.req_id)}
                          isGlobalFilter={true}
                          isAddOptions={false}
                          customPageSize={10}
                        />
                      </TabPane>
                    </TabContent>
                  </CardBody>
                </Card>
              )}
            </Col>
          </Row>
        </Container>
        <div
          ref={printRef}
          className="printable"
          style={{
            display: "none",
            // margin: "0 auto" /* Center the content horizontally */,
            padding: "1mm" /* Add padding to the content */,
            // border: "1px solid #000",
            fontSize: "10px" /* Adjust font size as needed */,
            // fontFamily: 'Courier Prime ,monospace',
          }}
        >
          <div className="text-center">
            <img src={profile} alt="" width={100} />
            <br />
            <QRCode
              value={`https://ecs.com.pk/track-form?TI=${trackID}`}
              className="mt-2"
            />
            <br />
            <b>Tracking ID: </b> {fdata.ecs_track_id}
            <br />
            <strong style={{ marginTop: "-10px" }}>NTN:</strong> 7942338-0{" "}
          </div>
          {/* Receipt Details */}
          <div className="col-12 mt-2">
            <div
              className="text-center"
              style={{ backgroundColor: "black", color: "white" }}
            >
              <b>Payment</b>
            </div>
            <b>Method:</b> {fdata.pay_method}
            <div className="float-end">
              <b>Date: </b> {fdata.b_date}
            </div>
            <br />
          </div>
          <div className="col-12">
            <div
              className="text-center"
              style={{ backgroundColor: "black", color: "white" }}
            >
              <b>Detail's</b>
            </div>
            <Row>
              <Col xl="12">
                <b>ORG-DEST</b> [{SEND}-{REC}]
                <br />
                <b>SRV: </b> {fdata.service_name}
                <div className="float-end">
                  {DocumentMode ? <b>SS: </b> : <></>}{" "}
                  {DocumentMode ? fdata.doc_sub_service : <></>}
                </div>
              </Col>
              <Col xl="12">
                <b>Staff</b>: {fdata.employee_id}
                <div className="float-end">
                  {DocumentMode ? <b>No. Docs: </b> : <></>}{" "}
                  {DocumentMode ? fdata.no_of_doc : <></>}
                </div>
              </Col>
            </Row>
          </div>
          <div className="col-12 ">
            <div
              className="text-center"
              style={{ backgroundColor: "black", color: "white" }}
            >
              {DocumentMode ? <b>Doc. Detail</b> : <b>Parcel Detail</b>}
            </div>
            <Row>
              <Col xl="12">
                <b>
                  {DocumentMode ? "Office Delivery: " : "Parcel Contents: "}
                </b>{" "}
                {DocumentMode
                  ? (() => {
                      switch (fdata.office_del) {
                        case "oto_":
                          return " OTO"
                        case "otd_":
                          return "OTD"
                        default:
                          return "Unknown"
                      }
                    })()
                  : fdata.content_name}
                <div className="float-end">
                  <b>
                    {DocumentMode ? "City Delivery: " : "Parcel Weight (kg): "}
                  </b>{" "}
                  {DocumentMode
                    ? (() => {
                        switch (fdata.city_del) {
                          case "wc_":
                            return "WC"
                          case "ctc_":
                            return "CTC"
                          default:
                            return "Unknown"
                        }
                      })()
                    : fdata.parcel_weight}
                </div>
              </Col>
              <Row>
                <Col xl={12}>
                  <div>
                    {""}
                    {DocumentMode ? (
                      <>
                        {" "}
                        <b>Detail :</b> {fdata.docs_detail}{" "}
                      </>
                    ) : (
                      <>
                        <b>No Of Contents:</b> {fdata.no_of_products}{" "}
                      </>
                    )}
                  </div>
                  {DocumentMode ?
                  <>
                <b>No Of Working Days:</b> {fdata.noOfWorkingDays}{" "} 
                  </>: null
            }
                </Col>
              </Row>
            </Row>
          </div>
          {DepChargesData.length > 0 && (
            <>
              <div className="col-12 ">
                <div
                  className="text-center"
                  style={{ backgroundColor: "black", color: "white" }}
                >
                  <b>Department Charges Documents</b>
                </div>
                <Row>
                  <Col xl="12">
                    <div className="table-responsive">
                      <Table className="table table-sm m-0">
                        <thead style={{ backgroundColor: "#F5F5F9" }}>
                          <tr>
                            <th>No.</th>
                            <th>Type</th>
                            <th>No. Of Doc</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {DepChargesData.length > 0 ? (
                            <>
                              {DepChargesData.filter(e => !!e).map(
                                (e, index) => (
                                  <tr key={index}>
                                    <td>
                                      <b>{index + 1}</b>{" "}
                                    </td>
                                    <td>
                                      <b>{e.dep_charges_type}</b>{" "}
                                    </td>
                                    <td>{e.dep_charges_doc_no} </td>
                                    <td>
                                      {parseFloat(
                                        e.dep_charge_amount
                                      ).toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "PKR",
                                      })}{" "}
                                    </td>
                                  </tr>
                                )
                              )}
                            </>
                          ) : (
                            <tr>
                              <td>No Data Found</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>
              </div>
            </>
          )}
          <div className="col-12 ">
            <div
              className="text-center"
              style={{ backgroundColor: "black", color: "white" }}
            >
              <b>Sender Info</b>
            </div>
            <b>Name </b> {fdata.s_name}
            <br />
            <b>Ph No. </b> {fdata.s_phone}
            <br />
            <b>Address </b> {fdata.s_address}
          </div>
          <div className="col-12 ">
            <div
              className="text-center"
              style={{ backgroundColor: "black", color: "white" }}
            >
              <b>Receiver Info</b>
            </div>
            <b>Name </b> {fdata.r_name}
            <br />
            <b>Ph No. </b> {fdata.r_phone}
            <br />
            <b>Address </b> {fdata.r_address}
          </div>
          {/* Total Amount */}
          <div className="col-12 ">
            <div
              className="text-center"
              style={{ backgroundColor: "black", color: "white" }}
            >
              <b>Amount</b>
            </div>
            {cvimode ? (
              <>
                <b>Ser Charges:</b>
                <div className="float-end">
                  {DocumentMode
                    ? Number(DocAmountWithountcvi).toLocaleString("en-US", {
                        style: "currency",
                        currency: "PKR",
                      })
                    : Number(ParcelChargesWithoutCVi).toLocaleString("en-US", {
                        style: "currency",
                        currency: "PKR",
                      })}
                </div>
                <br />
              </>
            ) : (
              <>
                <b>Ser Charges:</b>{" "}
                <div className="float-end">
                  {DocumentMode
                    ? Number(Dcharges).toLocaleString("en-US", {
                        style: "currency",
                        currency: "PKR",
                      })
                    : Number(Pcharges).toLocaleString("en-US", {
                        style: "currency",
                        currency: "PKR",
                      })}
                </div>
                <br />
              </>
            )}
            {cvimode ? (
              <>
                <b>CVI (2.5%): </b>
                <div className="float-end">
                  {DocumentMode
                    ? Number(DocCviAmount).toLocaleString("en-US", {
                        style: "currency",
                        currency: "PKR",
                      })
                    : Number(ParcelCviAmount).toLocaleString("en-US", {
                        style: "currency",
                        currency: "PKR",
                      })}
                </div>
                <br />
                <b>GST (15%): </b>
                <div className="float-end">
                  {DocumentMode
                    ? Number(DocgstAmount).toLocaleString("en-US", {
                        style: "currency",
                        currency: "PKR",
                      })
                    : Number(ParcelGSTAmount).toLocaleString("en-US", {
                        style: "currency",
                        currency: "PKR",
                      })}
                </div>
                <br />
                {riderCharges !== 0 && (
                  <>
                    <b>Rider Charges:</b>
                    <div className="float-end">
                      {riderCharges.toLocaleString("en-US", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </div>
                    <br />
                  </>
                )}
                {depChargesAmount !== 0 && (
                  <>
                    <hr
                      style={{
                        border: "1px solid rgba(0, 0, 0, 0.2)",
                        margin: "0",
                        padding: "0",
                      }}
                    />
                    <b>
                      Total Department Charges <br />
                      (excl. GST):{" "}
                    </b>
                    <div className="float-end">
                      {depChargesAmount
                        ? Number(depChargesAmount).toLocaleString("en-US", {
                            style: "currency",
                            currency: "PKR",
                          })
                        : 0.0}
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <b>GST (15%): </b>
                <div className="float-end">
                  {DocumentMode
                    ? Number(DocgstAmount).toLocaleString("en-US", {
                        style: "currency",
                        currency: "PKR",
                      })
                    : Number(ParcelGSTAmount).toLocaleString("en-US", {
                        style: "currency",
                        currency: "PKR",
                      })}
                </div>
                <br />
                {riderCharges !== 0 && (
                  <>
                    <b>Rider Charges:</b>
                    <div className="float-end">
                      {riderCharges.toLocaleString("en-US", {
                        style: "currency",
                        currency: "PKR",
                      })}
                    </div>
                    <br />
                  </>
                )}
                {depChargesAmount !== 0 && (
                  <>
                    <hr
                      style={{
                        border: "1px solid rgba(0, 0, 0, 0.2)",
                        margin: "0",
                        padding: "0",
                      }}
                    />
                    <b>
                      Total Department Charges <br />
                      (excl. GST):{" "}
                    </b>
                    <div className="float-end">
                      {depChargesAmount
                        ? Number(depChargesAmount).toLocaleString("en-US", {
                            style: "currency",
                            currency: "PKR",
                          })
                        : 0.0}
                    </div>
                  </>
                )}
              </>
            )}
            <br />
            <br />
            {cvimode ? (
              <>
                <b>Total: </b>{" "}
                <div className="float-end">
                  <b>
                    {DocumentMode
                      ? TotalDocCharges.toLocaleString("en-US", {
                          style: "currency",
                          currency: "PKR",
                        })
                      : TotalParCharges.toLocaleString("en-US", {
                          style: "currency",
                          currency: "PKR",
                        })}
                  </b>
                </div>
              </>
            ) : (
              <>
                <b>Total: </b>{" "}
                <div className="float-end">
                  <b>
                    {DocumentMode
                      ? TotalDocCharges.toLocaleString("en-US", {
                          style: "currency",
                          currency: "PKR",
                        })
                      : TotalParCharges.toLocaleString("en-US", {
                          style: "currency",
                          currency: "PKR",
                        })}
                  </b>
                </div>
              </>
            )}
          </div>
          <div style={{ borderTop: "1px solid gray", width: "100%" }}></div>
          <div className="text-center">
            For term's & conditions visit our site
            <br />
            ecs.com.pk
            {/* <br /> */}
            {/* Head Office No. 20/22 E,
            <br /> Mezzanine Floor, Saeed Plaza,
            <br /> Jinnah Avenue, Blue Area,
            <br /> Islamabad */}
            <br /> <strong>UAN</strong> : 051-111-327-327
          </div>
        </div>
        <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)}>
          <ModalHeader toggle={() => setIsModalOpen(false)}>
            {modalType === "PaidStatus" && "Update Paid Status"}
          </ModalHeader>

          <ModalBody>
            {selectedRow && (
              <>
                {modalType === "PaidStatus" && (
                  <FormGroup>
                    <Label>Payment Status</Label>
                    <Input
                      type="select"
                      value={paymentStatus}
                      onChange={e => setPaymentStatus(e.target.value)}
                    >
                      <option value="paid">Paid</option>
                      <option value="not-paid">Not Paid</option>
                    </Input>
                  </FormGroup>
                )}
              </>
            )}
          </ModalBody>

          <ModalFooter>
            <Button color="secondary" onClick={() => setIsModalOpen(false)}>
              Cancel
            </Button>
            <Button color="success" onClick={handleUpdatePaidStatus}>
              Save
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default TodayCourierDetail
